import { render, staticRenderFns } from "./DifficultyFilter.vue?vue&type=template&id=22abc5e3&scoped=true&"
import script from "./DifficultyFilter.vue?vue&type=script&lang=js&"
export * from "./DifficultyFilter.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyFilter.vue?vue&type=style&index=0&id=22abc5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abc5e3",
  null
  
)

export default component.exports